import React, {Component} from 'react';
import HomePage from './homePage';
import Footer from '../components/footer';
// Components
class Application extends Component {


/**
	state = {races: []}

componentDidMount() {
    fetch('/races')
      .then(res => res.json())
      .then(races => this.setState({ races }));
  }

*/
  render() {
    return (
       
        <div >
          <HomePage />
          <Footer />
     	</div>
    );
  }
}      

export default Application;




// WEBPACK FOOTER //
// ./src/containers/app.js